import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

export default function SupplyManage({ user }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState('stock'); // stock | request | transaction
  const [supplies, setSupplies] = useState([]);
  const [requests, setRequests] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(null); // 'request' | 'use' | 'return' | 'approve'
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({});

  const isManager = ['admin','manager'].includes(user.role);

  const fetchSupplies = async () => {
    setLoading(true);
    try {
      const res = await API.get('/supplies/supplies');
      setSupplies(res.data);
    } finally { setLoading(false); }
  };

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await API.get('/supplies/requests');
      setRequests(res.data);
    } finally { setLoading(false); }
  };

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const res = await API.get('/supplies/transactions');
      setTransactions(res.data);
    } finally { setLoading(false); }
  };

  useEffect(() => {
    if (tab === 'stock') fetchSupplies();
    else if (tab === 'request') fetchRequests();
    else fetchTransactions();
  }, [tab]);

  const handleRequest = async () => {
    if (!form.supply_name && !form.supply_id) { alert('请选择或填写物品名称'); return; }
    if (!form.quantity || !form.category || !form.department) { alert('请填写完整信息'); return; }
    try {
      const data = new FormData();
      Object.keys(form).forEach(k => { if (form[k] !== undefined && form[k] !== '') data.append(k, form[k]); });
      await API.post('/supplies/requests', data, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert('申请提交成功');
      setShowModal(null);
      fetchRequests();
    } catch (err) { alert(err.response?.data?.message || '提交失败'); }
  };

  const handleApprove = async (status) => {
    try {
      await API.put(`/supplies/requests/${selected.id}/approve`, { status, manager_note: form.manager_note, actual_cost: form.actual_cost });
      alert('审批完成');
      setShowModal(null);
      fetchRequests();
    } catch (err) { alert('操作失败'); }
  };

  const handleTransaction = async () => {
    if (!form.quantity) { alert('请填写数量'); return; }
    try {
      await API.post('/supplies/transactions', { supply_id: selected.id, type: showModal, quantity: parseInt(form.quantity), note: form.note });
      alert(`${showModal}成功`);
      setShowModal(null);
      fetchSupplies();
      fetchTransactions();
    } catch (err) { alert(err.response?.data?.message || '操作失败'); }
  };

  const openModal = (type, item = null) => {
    setSelected(item);
    setForm({});
    setShowModal(type);
  };

  const STATUS_COLOR = { '待审批': '#1890ff', '已批准': '#52c41a', '已拒绝': '#ff4d4f', '已入库': '#888' };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.back} onClick={() => navigate(-1)}>← 返回</button>
        <h2 style={styles.headerTitle}>物品管理</h2>
        <button style={styles.addBtn} onClick={() => openModal('request')}>申请</button>
      </div>

      {/* Tab切换 */}
      <div style={styles.tabs}>
        {[['stock','库存'],['request','申请'],['transaction','记录']].map(([k,v]) => (
          <button key={k} style={{...styles.tab, ...(tab===k ? styles.tabActive : {})}} onClick={() => setTab(k)}>{v}</button>
        ))}
      </div>

      <div style={styles.content}>
        {loading ? <div style={styles.loading}>加载中...</div> : (

          tab === 'stock' ? (
            <>
              {['秩序部','工程部','保洁部','管家部','绿化部'].map(dept => {
                const deptSupplies = supplies.filter(s => s.department === dept);
                if (!deptSupplies.length) return null;
                return (
                  <div key={dept}>
                    <div style={styles.deptTitle}>{dept}</div>
                    {['工具','耗材'].map(cat => {
                      const items = deptSupplies.filter(s => s.category === cat);
                      if (!items.length) return null;
                      return (
                        <div key={cat}>
                          <div style={styles.catTitle}>{cat}</div>
                          {items.map(s => (
                            <div key={s.id} style={styles.supplyCard}>
                              <div style={styles.supplyInfo}>
                                <span style={styles.supplyName}>{s.name}</span>
                                <span style={{...styles.stockBadge, background: s.stock > 0 ? '#f6ffed' : '#fff1f0', color: s.stock > 0 ? '#52c41a' : '#ff4d4f', borderColor: s.stock > 0 ? '#b7eb8f' : '#ffa39e'}}>
                                  库存：{s.stock} {s.unit||'个'}
                                </span>
                              </div>
                              <div style={styles.supplyActions}>
                                <button style={styles.actionBtn} onClick={() => openModal('取用', s)}>取用</button>
                                {s.category === '工具' && (
                                  <button style={{...styles.actionBtn, background:'#e6f7ff', color:'#1890ff'}} onClick={() => openModal('归还', s)}>归还</button>
                                )}
                                {user.role === 'admin' && (
                                  <>
                                    <button style={{...styles.actionBtn, background:'#f6ffed', color:'#52c41a'}} onClick={() => openModal('盘点', s)}>盘点</button>
                                    <button style={{...styles.actionBtn, background:'#fff1f0', color:'#ff4d4f'}} onClick={async () => {
                                      if (!window.confirm(`确定删除"${s.name}"？`)) return;
                                      try { await API.delete(`/supplies/supplies/${s.id}`); fetchSupplies(); }
                                      catch(e) { alert('删除失败'); }
                                    }}>删除</button>
                                  </>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </>
          ) : tab === 'request' ? (
            requests.map(r => (
              <div key={r.id} style={styles.reqCard}>
                <div style={styles.reqTop}>
                  <span style={styles.reqName}>{r.supply_name || r.supply_name_db}</span>
                  <span style={{...styles.statusBadge, background: STATUS_COLOR[r.status]}}>{r.status}</span>
                </div>
                <div style={styles.reqInfo}>
                  {r.department} · {r.category} · {r.quantity}{r.unit||'个'}
                  {r.estimated_cost ? ` · 预计¥${r.estimated_cost}` : ''}
                  {r.actual_cost ? ` · 实际¥${r.actual_cost}` : ''}
                </div>
                <div style={styles.reqFooter}>
                  <span>{r.requester_name} · {new Date(r.created_at).toLocaleDateString('zh-CN')}</span>
                  {isManager && r.status === '待审批' && (
                    <button style={styles.approveBtn} onClick={() => openModal('approve', r)}>审批</button>
                  )}
                  {isManager && r.status === '已批准' && (
                    <button style={{...styles.approveBtn, background:'#52c41a'}} onClick={() => openModal('instock', r)}>入库</button>
                  )}
                </div>
                {r.manager_note && <div style={styles.managerNote}>经理：{r.manager_note}</div>}
              </div>
            ))
          ) : (
            transactions.map(t => (
              <div key={t.id} style={styles.transCard}>
                <div style={styles.transTop}>
                  <span style={styles.transName}>{t.supply_name}</span>
                  <span style={{...styles.typeTag, background: t.type==='入库'?'#f6ffed':t.type==='取用'?'#fff7e6':'#e6f7ff', color: t.type==='入库'?'#52c41a':t.type==='取用'?'#fa8c16':'#1890ff'}}>
                    {t.type} {t.quantity}
                  </span>
                </div>
                <div style={styles.transFooter}>{t.operator_name} · {new Date(t.created_at).toLocaleString('zh-CN',{month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'})}</div>
                {t.note && <div style={styles.transNote}>{t.note}</div>}
              </div>
            ))
          )
        )}
      </div>

      {/* 弹窗 */}
      {showModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>
              {showModal==='request'?'申请购买':showModal==='approve'?'审批申请':showModal==='instock'?'确认入库':`${showModal}物品`}
            </h3>

            {showModal === 'request' && (
              <>
                <select style={styles.minput} value={form.supply_id||''} onChange={e => {
                  const s = supplies.find(x=>x.id===parseInt(e.target.value));
                  setForm({...form, supply_id: e.target.value, supply_name:'', category: s?.category||'', department: s?.department||''});
                }}>
                  <option value="">选择已有物品（或下方填写新物品）</option>
                  {supplies.map(s => <option key={s.id} value={s.id}>{s.name}（{s.department}·{s.category}）</option>)}
                </select>
                {!form.supply_id && <>
                  <input style={styles.minput} placeholder="新物品名称 *" value={form.supply_name||''} onChange={e => setForm({...form, supply_name:e.target.value})} />
                  <select style={styles.minput} value={form.category||''} onChange={e => setForm({...form, category:e.target.value})}>
                    <option value="">选择类别 *</option>
                    <option value="工具">工具</option>
                    <option value="耗材">耗材</option>
                  </select>
                  <select style={styles.minput} value={form.department||''} onChange={e => setForm({...form, department:e.target.value})}>
                    <option value="">选择部门 *</option>
                    <option value="保洁部">保洁部</option>
                    <option value="秩序工程部">秩序工程部</option>
                  </select>
                  <input style={styles.minput} placeholder="单位（如：个/瓶/套）" value={form.unit||''} onChange={e => setForm({...form, unit:e.target.value})} />
                </>}
                <input style={styles.minput} type="number" placeholder="申请数量 *" value={form.quantity||''} onChange={e => setForm({...form, quantity:e.target.value})} />
                <input style={styles.minput} type="number" placeholder="预计费用（元）" value={form.estimated_cost||''} onChange={e => setForm({...form, estimated_cost:e.target.value})} />
                <input style={styles.minput} placeholder="申请原因" value={form.reason||''} onChange={e => setForm({...form, reason:e.target.value})} />
              </>
            )}

            {showModal === 'approve' && (
              <>
                <div style={styles.approveInfo}>{selected?.supply_name} · {selected?.quantity}{selected?.unit||'个'} · 预计¥{selected?.estimated_cost||'未填'}</div>
                <input style={styles.minput} type="number" placeholder="实际费用（元）" value={form.actual_cost||''} onChange={e => setForm({...form, actual_cost:e.target.value})} />
                <input style={styles.minput} placeholder="经理意见（可选）" value={form.manager_note||''} onChange={e => setForm({...form, manager_note:e.target.value})} />
              </>
            )}

            {showModal === 'instock' && (
              <>
                <div style={styles.approveInfo}>{selected?.supply_name} · {selected?.quantity}{selected?.unit||'个'}</div>
                <input style={styles.minput} type="number" placeholder="实际费用（元）" value={form.actual_cost||''} onChange={e => setForm({...form, actual_cost:e.target.value})} />
              </>
            )}

            {(showModal==='取用'||showModal==='归还') && (
              <>
                <div style={styles.approveInfo}>{selected?.name} · 当前库存：{selected?.stock} {selected?.unit||'个'}</div>
                <input style={styles.minput} type="number" placeholder="数量 *" value={form.quantity||''} onChange={e => setForm({...form, quantity:e.target.value})} />
                <input style={styles.minput} placeholder="备注（可选）" value={form.note||''} onChange={e => setForm({...form, note:e.target.value})} />
              </>
            )}

            {showModal === '盘点' && (
              <>
                <div style={styles.approveInfo}>{selected?.name} · 当前库存：{selected?.stock} {selected?.unit||'个'}</div>
                <input style={styles.minput} type="number" placeholder="实际盘点数量 *" value={form.stock||''} onChange={e => setForm({...form, stock:e.target.value})} />
                <input style={styles.minput} placeholder="盘点备注（可选）" value={form.note||''} onChange={e => setForm({...form, note:e.target.value})} />
              </>
            )}

            <div style={styles.modalBtns}>
              <button style={styles.cancelBtn} onClick={() => setShowModal(null)}>取消</button>
              {showModal === 'request' && <button style={styles.confirmBtn} onClick={handleRequest}>提交</button>}
              {showModal === 'approve' && <>
                <button style={{...styles.confirmBtn, background:'#ff4d4f'}} onClick={() => handleApprove('已拒绝')}>拒绝</button>
                <button style={styles.confirmBtn} onClick={() => handleApprove('已批准')}>批准</button>
              </>}
              {showModal === 'instock' && <button style={styles.confirmBtn} onClick={async () => {
                try {
                  const data = new FormData();
                  if (form.actual_cost) data.append('actual_cost', form.actual_cost);
                  await API.put(`/supplies/requests/${selected.id}/instock`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
                  alert('入库成功'); setShowModal(null); fetchSupplies(); fetchRequests();
                } catch (err) { alert('操作失败'); }
              }}>确认入库</button>}
              {(showModal==='取用'||showModal==='归还') && <button style={styles.confirmBtn} onClick={handleTransaction}>确认</button>}
              {showModal==='盘点' && <button style={styles.confirmBtn} onClick={async () => {
                if (!form.stock && form.stock !== 0) { alert('请填写实际数量'); return; }
                try {
                  await API.put(`/supplies/supplies/${selected.id}/stock`, { stock: parseInt(form.stock), note: form.note });
                  alert('盘点成功');
                  setShowModal(null);
                  fetchSupplies();
                } catch(e) { alert('操作失败'); }
              }}>确认盘点</button>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f5f7fa', paddingBottom: '30px' },
  header: { background: 'linear-gradient(90deg, #7b2d8b, #a855c8)', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 },
  back: { background: 'transparent', border: 'none', color: '#fff', fontSize: '16px', cursor: 'pointer' },
  headerTitle: { color: '#fff', margin: 0, fontSize: '18px', fontWeight: 700 },
  addBtn: { background: '#fff', color: '#7b2d8b', border: 'none', borderRadius: '20px', padding: '8px 18px', fontSize: '15px', fontWeight: 600, cursor: 'pointer' },
  tabs: { display: 'flex', background: '#fff', borderBottom: '2px solid #f0f0f0' },
  tab: { flex: 1, padding: '12px', border: 'none', background: 'transparent', fontSize: '15px', cursor: 'pointer', color: '#888' },
  tabActive: { color: '#7b2d8b', borderBottom: '2px solid #7b2d8b', fontWeight: 700 },
  content: { padding: '16px' },
  loading: { textAlign: 'center', padding: '40px', color: '#888' },
  deptTitle: { fontSize: '14px', fontWeight: 700, color: '#7b2d8b', padding: '8px 0 4px', borderBottom: '1px solid #e0e0e0', marginBottom: '8px' },
  catTitle: { fontSize: '13px', color: '#888', padding: '4px 0', marginBottom: '4px' },
  supplyCard: { background: '#fff', borderRadius: '10px', padding: '12px', marginBottom: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  supplyInfo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  supplyName: { fontSize: '15px', fontWeight: 600, color: '#222' },
  stockBadge: { display: 'inline-block', border: '1px solid', borderRadius: '4px', padding: '1px 8px', fontSize: '12px' },
  supplyActions: { display: 'flex', gap: '6px' },
  actionBtn: { padding: '6px 14px', background: '#fff7e6', color: '#fa8c16', border: '1px solid #ffd591', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' },
  reqCard: { background: '#fff', borderRadius: '10px', padding: '12px', marginBottom: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  reqTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' },
  reqName: { fontSize: '15px', fontWeight: 600, color: '#222' },
  statusBadge: { color: '#fff', borderRadius: '4px', padding: '2px 8px', fontSize: '12px' },
  reqInfo: { fontSize: '13px', color: '#666', marginBottom: '6px' },
  reqFooter: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', color: '#999' },
  approveBtn: { padding: '4px 12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' },
  managerNote: { marginTop: '6px', fontSize: '13px', color: '#888', background: '#f5f5f5', borderRadius: '4px', padding: '4px 8px' },
  transCard: { background: '#fff', borderRadius: '10px', padding: '12px', marginBottom: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  transTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' },
  transName: { fontSize: '15px', fontWeight: 600, color: '#222' },
  typeTag: { borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: 600 },
  transFooter: { fontSize: '12px', color: '#999' },
  transNote: { fontSize: '13px', color: '#888', marginTop: '4px' },
  modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 200 },
  modalContent: { background: '#fff', width: '100%', borderRadius: '16px 16px 0 0', padding: '24px 20px', maxHeight: '85vh', overflowY: 'auto' },
  modalTitle: { margin: '0 0 16px', fontSize: '18px', fontWeight: 700, color: '#7b2d8b' },
  minput: { display: 'block', width: '100%', padding: '11px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '15px', marginBottom: '10px', boxSizing: 'border-box' },
  approveInfo: { background: '#f5f5f5', borderRadius: '8px', padding: '10px', fontSize: '14px', color: '#333', marginBottom: '12px' },
  modalBtns: { display: 'flex', gap: '10px', marginTop: '8px' },
  cancelBtn: { flex: 1, padding: '12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '16px', background: '#fff', cursor: 'pointer' },
  confirmBtn: { flex: 1, padding: '12px', background: '#7b2d8b', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 600, cursor: 'pointer' }
};
